const React = require('react');
const { useContext } = React;
const { LeaderContext } = require('./WeeklyLeaders');
const LeaderFrame = require('./LeaderFrame');

module.exports = function WeeklyFrame({ userId, children, style }) {

    const ranks = useContext(LeaderContext);
    const metal = { 1: 'Gold', 2: 'Silver', 3: 'Bronze' }[ranks[userId]];
    if (!metal) { return children; }
    return <LeaderFrame as='span' $metal={metal} data-leader-frame={metal} aria-label={`${metal} weekly leader`} style={{ display: 'inline-flex', width: 'auto', maxWidth: 'none', margin: 0, borderRadius: '50%', ...style }}>{children}</LeaderFrame>;
};
